/// <amd-module name="typeahead/features/HierarchicalSuggestion" />
/// <amd-dependency path="jquery" name="$"/>

/// <reference path="../../typings/typeahead/suggestionsProvider.d.ts"/>

import {IExperimentalFeature} from "typeahead/core/IExperimentalFeature";
import * as ExecutionHelper from "typeahead/core/plugins/ExecutionHelper";
import {IStripingConfiguration} from "typeahead/core/StripingConfiguration";
import * as StripingConfiguration from "typeahead/core/StripingConfiguration";
import {IEssSuggestionResult} from "typeahead/core/Suggestion";
import {PackageType, TypeaheadUtils} from "typeahead/core/TypeaheadUtils";
import {addFeatureFlag} from "typeahead/dataprovider/suggestservice/SuggestServiceQueryParamsUtils";

const configuration: IStripingConfiguration[] = [
    {
        clients: ["Flights.Search"],
        experiment: {
            id: 15333,
            name: "FSRP_uTA_Hierarchy",
            value: 1,
        },
    },
    {
       lobs: ["HOTELS", "FLIGHTS", "RAILS", "PACKAGES"],
    },
];

const featureFlag = "ta_hierarchy";

export class HierarchicalSuggestion implements IExperimentalFeature, IRequestUrlParamModifier, ISuggestionsModifier {
    public getExperiments(): UtaExperiment[] {
        return StripingConfiguration.getExperiments(configuration);
    }

    public modifyParameters(params: ISuggestServiceQueryParams, context: IContext, options?: any):
            JQueryPromise<ISuggestServiceQueryParams> {
        if (TypeaheadUtils.getPackageType() !== PackageType.FlightCar) {
            return addFeatureFlag(featureFlag, configuration, params, context, options);
        } else {
            let deferred: JQueryDeferred<ISuggestServiceQueryParams> = $.Deferred();
            return deferred.resolve(params).promise();
        }
    }

    public modifySuggestions(suggestions: IEssSuggestionResult[], context: IContext, options: any):
            JQueryPromise<Object[]> {
        let deferred: JQueryDeferred<Object[]> = $.Deferred();
        if (suggestions && suggestions.length > 0) {
            ExecutionHelper.shouldExecute(context, configuration)
                .done((shouldExecute) => {
                    suggestions.forEach((sugg: IEssSuggestionResult): void => {
                        if (shouldExecute) {
                            let obj: string[] = sugg.relation;
                            if (+sugg.index > 0 && sugg.hierarchyInfo) {
                                obj = sugg.hierarchyInfo.relation;
                            }
                            if (obj && (obj[0] === "child" || obj[0] === "nearby")) {
                                // Set the flag to show as hierarchy option
                                sugg.showAsHierarchy = true;
                            }
                        }
                    });
                })
                .always(() => {
                    deferred.resolve(suggestions);
                });
        } else {
            deferred.resolve(suggestions);
        }
        return deferred.promise();
    }
}
